
type Props = {
  imageUrl?: string,
  size?: 'lg' | 'md' | 'sm',
  className?: string
}

const sizes = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

export function Avatar({ imageUrl, className }: Props) {
  return <img src={imageUrl} className={`select-none size-9 rounded-full border-2 border-[#EBEBEB] shrink-0 cursor-pointer ${className}`} alt='avatar' />
}